import "./style.css";
const u = (r, o) => {
  var c;
  return l((c = r.data) == null ? void 0 : c.blocks, o);
}, l = (r, o) => {
  var c, e, i;
  if (!r)
    return null;
  for (const n of r) {
    if (n.id === o)
      return n;
    if (n.children) {
      const t = l(n.children, o);
      if (t)
        return t;
    }
    if (((c = n.component) == null ? void 0 : c.name) === "Columns" && ((i = (e = n.component) == null ? void 0 : e.options) != null && i.columns)) {
      for (const t of n.component.options.columns)
        if (t.blocks) {
          const f = l(t.blocks, o);
          if (f)
            return f;
        }
    }
  }
  return null;
};
export {
  u as f
};
